/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiChannelBindings } from '../models/AaiChannelBindings';
import { AaiChannelBindingsDefinition } from '../models/AaiChannelBindingsDefinition';
import { AaiChannelItem } from '../models/AaiChannelItem';
import { AaiCorrelationId } from '../models/AaiCorrelationId';
import { AaiHeaderItem } from '../models/AaiHeaderItem';
import { AaiMessage } from '../models/AaiMessage';
import { AaiMessageBindings } from '../models/AaiMessageBindings';
import { AaiMessageBindingsDefinition } from '../models/AaiMessageBindingsDefinition';
import { AaiMessageTrait } from '../models/AaiMessageTrait';
import { AaiMessageTraitDefinition } from '../models/AaiMessageTraitDefinition';
import { AaiOperationBindings } from '../models/AaiOperationBindings';
import { AaiOperationBindingsDefinition } from '../models/AaiOperationBindingsDefinition';
import { AaiOperationTrait } from '../models/AaiOperationTrait';
import { AaiOperationTraitDefinition } from '../models/AaiOperationTraitDefinition';
import { AaiParameter } from '../models/AaiParameter';
import { AaiServerBindings } from '../models/AaiServerBindings';
import { AaiServerBindingsDefinition } from '../models/AaiServerBindingsDefinition';
import { AuthorizationCodeOAuthFlow } from '../../core/models/common/AuthorizationCodeOAuthFlow';
import { ClientCredentialsOAuthFlow } from '../../core/models/common/ClientCredentialsOAuthFlow';
import { Components } from '../../core/models/common/Components';
import { ImplicitOAuthFlow } from '../../core/models/common/ImplicitOAuthFlow';
import { OAuthFlows } from '../../core/models/common/OAuthFlows';
import { PasswordOAuthFlow } from '../../core/models/common/PasswordOAuthFlow';
import { Server } from '../../core/models/common/Server';
import { ServerVariable } from '../../core/models/common/ServerVariable';
import { AllNodeVisitor } from '../../core/visitors/AllNodeVisitor';

/**
 * @author eric.wittmann@gmail.com
 * @author Jakub Senko <jsenko@redhat.com>
 * @class
 * @extends AllNodeVisitor
 */
export class AaiAllNodeVisitor extends AllNodeVisitor implements IAaiVisitor {
    /**
     * 
     * @param {AuthorizationCodeOAuthFlow} node
     */
    public visitAuthorizationCodeOAuthFlow(node : AuthorizationCodeOAuthFlow) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiChannelItem} node
     */
    public visitChannelItem(node : AaiChannelItem) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {ClientCredentialsOAuthFlow} node
     */
    public visitClientCredentialsOAuthFlow(node : ClientCredentialsOAuthFlow) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {Components} node
     */
    public visitComponents(node : Components) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiCorrelationId} node
     */
    public visitCorrelationId(node : AaiCorrelationId) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiHeaderItem} node
     */
    public visitHeaderItem(node : AaiHeaderItem) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {ImplicitOAuthFlow} node
     */
    public visitImplicitOAuthFlow(node : ImplicitOAuthFlow) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiMessage} node
     */
    public visitMessage(node : AaiMessage) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiMessageTrait} node
     */
    public visitMessageTrait(node : AaiMessageTrait) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {OAuthFlows} node
     */
    public visitOAuthFlows(node : OAuthFlows) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiOperationTrait} node
     */
    public visitOperationTrait(node : AaiOperationTrait) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {PasswordOAuthFlow} node
     */
    public visitPasswordOAuthFlow(node : PasswordOAuthFlow) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {Server} node
     */
    public visitServer(node : Server) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {ServerVariable} node
     */
    public visitServerVariable(node : ServerVariable) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiParameter} node
     */
    public visitAaiParameter(node : AaiParameter) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiServerBindings} node
     */
    public visitServerBindings(node : AaiServerBindings) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiServerBindingsDefinition} node
     */
    public visitServerBindingsDefinition(node : AaiServerBindingsDefinition) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiOperationBindings} node
     */
    public visitOperationBindings(node : AaiOperationBindings) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiOperationBindingsDefinition} node
     */
    public visitOperationBindingsDefinition(node : AaiOperationBindingsDefinition) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiMessageBindings} node
     */
    public visitMessageBindings(node : AaiMessageBindings) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiMessageBindingsDefinition} node
     */
    public visitMessageBindingsDefinition(node : AaiMessageBindingsDefinition) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiChannelBindings} node
     */
    public visitChannelBindings(node : AaiChannelBindings) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiChannelBindingsDefinition} node
     */
    public visitChannelBindingsDefinition(node : AaiChannelBindingsDefinition) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiMessageTraitDefinition} node
     */
    public visitMessageTraitDefinition(node : AaiMessageTraitDefinition) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiOperationTraitDefinition} node
     */
    public visitOperationTraitDefinition(node : AaiOperationTraitDefinition) {
        this.visitNode(node);
    }

    constructor() {
        super();
    }
}
AaiAllNodeVisitor["__class"] = "io.apicurio.datamodels.asyncapi.visitors.AaiAllNodeVisitor";
AaiAllNodeVisitor["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor"];





import { IAaiVisitor } from './IAaiVisitor';

